<template>
  <div class="home">
    <scripts />
  </div>
</template>

<script>
import Scripts from "@/components/views/Scripts"
export default {
  name: "ScriptsView",
  components: {Scripts}
}
</script>

<style scoped>

</style>
